import { render, staticRenderFns } from "./WjStat.vue?vue&type=template&id=7f4e7db6&scoped=true&"
import script from "./WjStat.vue?vue&type=script&lang=js&"
export * from "./WjStat.vue?vue&type=script&lang=js&"
import style0 from "./WjStat.vue?vue&type=style&index=0&id=7f4e7db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4e7db6",
  null
  
)

export default component.exports